import { createAction } from '@reduxjs/toolkit';

import { QualificationStepResponse } from '../../../domain/qualification';

const NAMESPACE = 'application';

const continueApplicationProcessing = createAction<{
  redirect: boolean;
  response: QualificationStepResponse;
}>(`${NAMESPACE}/continue-application-processing`);

export { continueApplicationProcessing };
